import { ToolResult } from '../../types/tool.types';
import { ToolContext } from '../tool-context.type';

export async function rotateCamera(args: any, context: ToolContext): Promise<ToolResult> {
	const { threeInstance, publish } = context;
	if (!threeInstance) {
		return { success: false, error: 'Three.js instance not initialized' };
	}

	const { angle, elevation, duration } = args;
	if (typeof angle !== 'number') {
		return { success: false, error: 'angle parameter must be a number' };
	}

	await threeInstance.rotateCamera(angle, elevation, duration);
	
	publish('camera', 'change', {
		ref: 'rotate',
		old: null,
		new: { angle, elevation, duration }
	});

	return { success: true, data: { angle, elevation, duration }};
}
